import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1, _templateObject10, _templateObject11, _templateObject12, _templateObject13;
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import isEqual from 'lodash.isequal';
import Link from '@/components/atoms/Link';
import { colorPalette, fonts, shadows } from '../styles/styleGuide';
import Caret from './shared/icons/Caret';
import Triangle from './shared/designElements/Triangle';
import NotificationsNumber from './NotificationNumber';
var FLYOUTMENUMARGINFROMTARGET = 20;
var FlyOutMenu = /*#__PURE__*/function (_Component) {
  function FlyOutMenu() {
    var _this;
    _classCallCheck(this, FlyOutMenu);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FlyOutMenu, [].concat(args));
    _defineProperty(_this, "subMenus", {});
    _defineProperty(_this, "container", null);
    _defineProperty(_this, "state", {
      top: 0,
      left: 0,
      arrowPos: {
        direction: 'top',
        top: 0,
        left: 0
      },
      openSubMenu: ''
    });
    return _this;
  }
  _inherits(FlyOutMenu, _Component);
  return _createClass(FlyOutMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var options = this.props.options;
      options.forEach(function (option) {
        if (option && option.active) {
          _this2.setState({
            openSubMenu: option.link
          });
        }
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props = this.props,
        target = _this$props.target,
        position = _this$props.position;
      if (!target) return;
      var targetEl = target.getBoundingClientRect();
      var flyoutMenu = this.container ? this.container.getBoundingClientRect() : {
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        top: 0,
        bottom: 0,
        left: 0,
        right: 0
      };
      var pos = {
        top: 0,
        left: 0
      };
      var arrowPos = {
        direction: 'top',
        top: 0,
        left: 0
      };
      var flyoutMenuTooWide = targetEl.left + targetEl.width / 2 - flyoutMenu.width / 2 + flyoutMenu.width > (window && window.innerWidth);
      switch (position) {
        case 'top':
          pos.top = targetEl.top - flyoutMenu.height - FLYOUTMENUMARGINFROMTARGET;
          pos.left = targetEl.left + targetEl.width / 2 - flyoutMenu.width / 2;
          break;
        case 'right':
          pos.top = targetEl.top + targetEl.height / 2 - flyoutMenu.height / 2;
          pos.left = targetEl.right + FLYOUTMENUMARGINFROMTARGET;
          arrowPos.top = flyoutMenu.height / 2 - 10;
          arrowPos.left = -10;
          arrowPos.direction = 'left';
          break;
        case 'bottom':
          pos.top = targetEl.top + targetEl.height + FLYOUTMENUMARGINFROMTARGET;
          pos.left = flyoutMenuTooWide ? 0 : targetEl.left + targetEl.width / 2 - flyoutMenu.width / 2;
          arrowPos.top = -10;
          arrowPos.left = flyoutMenu.width / 2 - 10;
          arrowPos.direction = 'top';
          break;
        case 'left':
          pos.top = targetEl.top + targetEl.height / 2 - flyoutMenu.height / 2;
          pos.left = targetEl.left - flyoutMenu.width - FLYOUTMENUMARGINFROMTARGET;
          arrowPos.top = flyoutMenu.height / 2 - 10;
          arrowPos.left = flyoutMenu.width - 11;
          arrowPos.direction = 'right';
          break;
        default:
          break;
      }
      var newState = _objectSpread(_objectSpread({}, pos), {}, {
        arrowPos: arrowPos,
        openSubMenu: prevState.openSubMenu
      });
      if (!isEqual(prevState, newState)) {
        this.setState(newState);
      }
    }
  }, {
    key: "renderItem",
    value: function renderItem(item) {
      return __jsx("div", {
        "data-id": "components_FlyOutMenu_div"
      }, item.icon && __jsx(IconWrapper, {
        "data-id": "components_FlyOutMenu_IconWrapper"
      }, item.icon, Number(item.unreadCount) > 0 && __jsx(NotificationBubble, {
        number: item.unreadCount || 0,
        "data-id": "components_FlyOutMenu_NotificationBubble"
      })), __jsx(LabelWrapper, {
        "data-id": "components_FlyOutMenu_LabelWrapper"
      }, item.label));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props2 = this.props,
        _this$props2$options = _this$props2.options,
        options = _this$props2$options === void 0 ? [] : _this$props2$options,
        visible = _this$props2.visible;
      var _this$state = this.state,
        arrowPos = _this$state.arrowPos,
        top = _this$state.top,
        left = _this$state.left,
        openSubMenu = _this$state.openSubMenu;
      return __jsx(HoverMenuContainer, {
        visible: visible,
        ref: function ref(el) {
          _this3.container = el;
        },
        style: {
          top: "".concat(top, "rem"),
          left: left === 0 ? 'initial' : "".concat(left, "rem")
        },
        "data-id": "components_FlyOutMenu_HoverMenuContainer"
      }, options.map(function (item, index) {
        var isActive = item ? item.active || openSubMenu === item.link : false;
        var isOpen = item ? openSubMenu === item.link : false;
        return item && !item.disable && item.type === 'link' ? __jsx(ListItem, {
          key: item.name,
          type: item.name,
          "data-id": "components_FlyOutMenu_ListItem"
        }, __jsx(Link, {
          href: item.link || '',
          "data-e2e-flyoutmenu-option": item.name,
          "data-id": "components_FlyOutMenu_Link"
        }, _this3.renderItem(item))) : item && !item.disable && item.type === 'button' ? __jsx(ListItem, {
          key: item.name,
          type: item.name,
          "data-id": "components_FlyOutMenu_ListItem"
        }, __jsx(Button, {
          onClick: item.onClick,
          "data-e2e-flyoutmenu-option": item.name,
          "data-id": "components_FlyOutMenu_Button"
        }, _this3.renderItem(item))) : item && !item.disable && item.type === 'message' ? __jsx(ListItem, {
          key: item.name,
          type: item.name,
          "data-id": "components_FlyOutMenu_ListItem"
        }, __jsx(Message, {
          "data-e2e-flyoutmenu-option": item.name,
          "data-id": "components_FlyOutMenu_Message"
        }, _this3.renderItem(item))) : item && !item.hidden && item.type === 'menu' ? __jsx(MenuWrapper, {
          key: item.name,
          "data-id": "components_FlyOutMenu_MenuWrapper"
        }, item.subLinks && item.subLinks.length > 0 ? __jsx(Menu, {
          "data-id": "components_FlyOutMenu_Menu"
        }, __jsx(MenuItem, {
          onClick: function onClick() {
            return _this3.setState({
              openSubMenu: isOpen ? '' : item.link
            });
          },
          color: isActive ? colorPalette.blue : colorPalette.headerGrey,
          "data-id": "components_FlyOutMenu_MenuItem"
        }, item.label, __jsx(CaretContainer, {
          isActive: isActive,
          "data-id": "components_FlyOutMenu_CaretContainer"
        }, __jsx(Caret, {
          direction: "down",
          color: isActive ? colorPalette.blue : colorPalette.headerGrey,
          "data-id": "components_FlyOutMenu_Caret"
        }))), __jsx(HoverMenu, {
          open: isOpen,
          height: _this3.subMenus[index] && _this3.subMenus[index].clientHeight,
          isLast: index === options.length - 1,
          "data-id": "components_FlyOutMenu_HoverMenu"
        }, __jsx("div", {
          ref: function ref(el) {
            _this3.subMenus[index] = el;
          },
          "data-id": "components_FlyOutMenu_div"
        }, item.subLinks.map(function (subLink) {
          return !subLink.hidden && __jsx(MenuLink, {
            key: subLink.label,
            color: subLink.active ? colorPalette.blue : colorPalette.headerGrey,
            href: subLink.link || '',
            "data-id": "components_FlyOutMenu_MenuLink"
          }, subLink.label);
        })))) : __jsx(MenuLink, {
          color: isActive ? colorPalette.blue : colorPalette.headerGrey,
          href: item.link || '',
          "data-id": "components_FlyOutMenu_MenuLink_19"
        }, item.label)) : null;
      }), __jsx(ArrowContainer, {
        position: arrowPos,
        "data-id": "components_FlyOutMenu_ArrowContainer"
      }, __jsx(Triangle, {
        direction: arrowPos.direction,
        color: "#ffffff",
        height: 20,
        width: 20,
        "data-id": "components_FlyOutMenu_Triangle"
      })));
    }
  }]);
}(Component);
export default FlyOutMenu;
var HoverMenuContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  position: fixed;\n  z-index: 2;\n  min-width: 168rem;\n  width: fit-content;\n  max-width: 264rem;\n  right: 0;\n  padding: 10rem 20rem;\n  box-sizing: border-box;\n  opacity: ", ";\n  pointer-events: ", ";\n  background-color: #fff;\n  transition: opacity 0.4s ease-in-out;\n  ", ";\n"])), function (props) {
  return props.visible ? '1' : '0';
}, function (props) {
  return props.visible ? 'auto' : 'none';
}, shadows.boxPrimaryHover);
var NotificationBubble = styled(NotificationsNumber)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([""])));
var MenuWrapper = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: 100%;\n  font-size: 18rem;\n  font-weight: bold;\n  font-family: ", ";\n"])), fonts.primary);
var HoverMenu = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  padding: 0 32rem;\n  margin: ", ";\n  height: ", ";\n  transition: height 0.25s;\n  overflow: hidden;\n"])), colorPalette.background, function (_ref) {
  var isLast = _ref.isLast;
  return isLast ? '0 -20rem -10rem' : '0 -20rem -0';
}, function (_ref2) {
  var open = _ref2.open,
    height = _ref2.height;
  return open ? height ? "".concat(height, "rem") : 'auto' : 0;
});
var Menu = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral([""])));
var sharedMenuStyles = function sharedMenuStyles(color) {
  return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  text-align: left;\n  width: 100%;\n  color: ", ";\n  padding 10rem 0;\n  transition: transform 0.25s;\n\n  &:hover {\n    color: ", ";\n\n    svg {\n      transform: rotateZ(180deg) scale(1);\n\n      > g {\n        fill: ", ";\n      }\n    }\n  }\n"])), color, colorPalette.blue, colorPalette.blue);
};
var MenuLink = styled(Link)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", ";\n  text-decoration: none;\n"])), function (_ref3) {
  var color = _ref3.color;
  return sharedMenuStyles(color);
});
var MenuItem = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  ", ";\n  cursor: pointer;\n  text-transform: uppercase;\n"])), function (_ref4) {
  var color = _ref4.color;
  return sharedMenuStyles(color);
});
var CaretContainer = styled.span(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: inline-block;\n  margin-left: 8px;\n  transform: rotateX(", "deg);\n  transition: transform 0.25s;\n"])), function (props) {
  return props.isActive ? 180 : 0;
});
var ListItem = styled.div(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  align-items: center;\n  color: ", ";\n  text-decoration: none;\n  font-family: ", ";\n  font-weight: normal;\n  font-size: 16rem;\n  line-height: 24rem;\n\n  > a,\n  > button,\n  > div {\n    display: flex;\n    width: 100%;\n    color: ", ";\n    text-decoration: none;\n    padding: 10rem 0;\n\n    > div {\n      display: flex;\n      width: 100%;\n      align-items: center;\n    }\n\n    ", ";\n  }\n\n  &:hover {\n    ", " {\n      background-color: ", ";\n    }\n  }\n"])), colorPalette.textGrey, fonts.primary, colorPalette.textGrey, function (props) {
  return props.type === 'messages' ? "&:hover{\n          color: ".concat(colorPalette.blue, ";\n          > div > div > svg > g > g > g > g > path {\n            &:nth-of-type(2) {\n              fill: ").concat(colorPalette.blue, ";\n            }\n          }\n        }\n        > div > div > svg > g > g > g > g > path {\n          &:nth-of-type(2) {\n            fill: ").concat(colorPalette.beige, ";\n            transition: fill 0.4s ease-in-out;\n          }\n        }") : "&:hover{\n          color: ".concat(colorPalette.blue, ";\n          > div > div > svg > g > g {\n            fill: ").concat(colorPalette.blue, ";\n          }\n        }\n        > div > div > svg > g > g {\n          fill: ").concat(colorPalette.beige, ";\n          transition: fill 0.4s ease-in-out;\n        }");
}, NotificationBubble, colorPalette.darkOrange);
var Message = styled.div(_templateObject1 || (_templateObject1 = _taggedTemplateLiteral([""])));
var Button = styled.button(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral([""])));
var IconWrapper = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  margin-right: 12rem;\n  width: 20rem;\n  height: 20rem;\n  position: relative;\n"])));
var LabelWrapper = styled.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral([""])));
var ArrowContainer = styled.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  position: absolute;\n  left: ", ";\n  top: ", ";\n"])), function (props) {
  return "".concat(props.position.left, "rem");
}, function (props) {
  return "".concat(props.position.top, "rem");
});